



















































import { Vue, Component } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import InstantMatchIntroductionDialog from '@/modules/instant/components/InstantMatchIntroductionDialog'
import TournamentCheckInOverlay from '@/modules/instant/components/TournamentCheckInOverlay'
import TournamentRegistrationClosedDialog from '@/modules/tournament/components/TournamentRegistrationClosedDialog'
import TournamentProgress from '@/modules/tournament/components/TournamentProgress'

@Component({
  components: {
    InstantMatchIntroductionDialog,
    TournamentCheckInOverlay,
    TournamentRegistrationClosedDialog,
    TournamentProgress
  }
})
export default class InstantMatchLayout extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)

  openIntroductionDialog() {
    this.tournamentModule.setInstantMatchIntroductionDialogVisible(true)
  }
}
